import { useEffect } from "react";

const psiToBar = (psi, decimals = 2) => {
    const bar = parseFloat(psi) * 0.0689476;
    return parseFloat(bar.toFixed(decimals));
};

function DDUMainTires({value, userData}) {
    useEffect(() => {
        if (userData["pressure-unit"] === "bar") {
            value["tyre-FL:pressure"] = psiToBar(value["tyre-FL:pressure"])
            value["tyre-FR:pressure"] = psiToBar(value["tyre-FR:pressure"])
            value["tyre-RL:pressure"] = psiToBar(value["tyre-RL:pressure"])
            value["tyre-RR:pressure"] = psiToBar(value["tyre-RR:pressure"])
        }
    }, [userData])

    const getTyreCompoundName = (v) => {
        if (v.includes("dry")) {
            return "Dry"
        } else if (v.includes("wet")) {
            return "Wet"
        } else {
            return "Unkown"
        }
    };

    const getTyreTempColor = (v) => {
        const colorClass = v < 50 ? "bg-acc-blue" 
                        : v < 90 ? "bg-acc-green" 
                        : v < 120 ? "bg-acc-yellow" 
                        : "bg-acc-red";

        return `block w-[20px] h-[35px] rounded-[3px] ${colorClass} transition-colors duration-300`;
    };

    const getBrakeTempColor = (v) => {
        const colorClass = v < 180 ? "bg-acc-blue" 
                        : v < 600 ? "bg-acc-green" 
                        : v < 850 ? "bg-acc-yellow"
                        : "bg-acc-red" 

        return `block ${colorClass} w-[7px] h-[25px] rounded-[1px] transition-colors duration-300`;
    };

    return (
        <>
            <p className={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute text-white p-1 top-[-13px] px-2 text-[12px] font-bold`}>TIRES</p>
            <span className={`${value["pit-limiter"] === 1 ? "bg-[#094fca]" : "bg-[#0e2640]"} absolute text-white py-[3px] px-3 rounded-[20px] font-bold uppercase`}>{getTyreCompoundName(value["tyre-compound"])} {value["current-tyre-set"]}</span>

            <div className="grid grid-cols-2 grid-rows-2 w-full h-full">
                <div className="flex items-center justify-center border-[#137fec33] border-r-[1px] border-b-[1px]">
                    <div className="flex flex-col w-full h-full items-center">
                        <div className="flex h-[55%] justify-center items-end">
                            <h1 className="text-[37px] font-bold">{(Math.floor(value["tyre-FL:pressure"] * 10) / 10).toFixed(1)}</h1>
                        </div>

                        <div className="flex h-[30%] justify-between items-center gap-3">
                            <p>{Math.trunc(value["tyre-FL:temp"])}°</p>

                            <div className="flex justify-center items-center gap-[3px]">
                                <div className={getTyreTempColor(Math.trunc(value["tyre-FL:temp"]))}></div>
                                <div className={getBrakeTempColor(value["brake-FL:temp"])}></div>
                            </div>

                            <p>{Math.trunc(value["brake-FL:temp"])}°</p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center border-[#137fec33] border-l-[1px] border-b-[1px]">
                    <div className="flex flex-col w-full h-full items-center">
                        <div className="flex h-[55%] justify-center items-end">
                            <h1 className="text-[37px] font-bold">{(Math.floor(value["tyre-FR:pressure"] * 10) / 10).toFixed(1)}</h1>
                        </div>

                        <div className="flex h-[30%] justify-between items-center gap-3">
                            <p>{Math.trunc(value["brake-FR:temp"])}°</p>

                            <div className="flex justify-center items-center gap-[3px]">
                                <div className={getBrakeTempColor(value["brake-FR:temp"])}></div>
                                <div className={getTyreTempColor(Math.trunc(value["tyre-FR:temp"]))}></div>
                            </div>

                            <p>{Math.trunc(value["tyre-FR:temp"])}°</p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center border-[#137fec33] border-r-[1px] border-t-[1px]">
                    <div className="flex flex-col w-full h-full items-center">
                        <div className="flex h-[55%] justify-center items-end">
                            <h1 className="text-[37px] font-bold">{(Math.floor(value["tyre-RL:pressure"] * 10) / 10).toFixed(1)}</h1>
                        </div>

                        <div className="flex h-[30%] justify-between items-center gap-3">
                            <p>{Math.trunc(value["tyre-RL:temp"])}°</p>

                            <div className="flex justify-center items-center gap-[3px]">
                                <div className={getTyreTempColor(Math.trunc(value["tyre-RL:temp"]))}></div>
                                <div className={getBrakeTempColor(value["brake-RL:temp"])}></div>
                            </div>

                            <p>{Math.trunc(value["brake-RL:temp"])}°</p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center border-[#137fec33] border-l-[1px] border-t-[1px]">
                    <div className="flex flex-col w-full h-full items-center">
                        <div className="flex h-[55%] justify-center items-end">
                            <h1 className="text-[37px] font-bold">{(Math.floor(value["tyre-RR:pressure"] * 10) / 10).toFixed(1)}</h1>
                        </div>

                        <div className="flex h-[30%] justify-between items-center gap-3">
                            <p>{Math.trunc(value["brake-RR:temp"])}°</p>

                            <div className="flex justify-center items-center gap-[3px]">
                                <div className={getBrakeTempColor(value["brake-RR:temp"])}></div>
                                <div className={getTyreTempColor(Math.trunc(value["tyre-RR:temp"]))}></div>
                            </div>

                            <p>{Math.trunc(value["tyre-RR:temp"])}°</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DDUMainTires;